var _path;
import * as React from "react";
function SvgMartini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 21,7.5 v -2 H 3 v 2 l 8,9 v 5 H 6 v 2 h 12 v -2 h -5 v -5 z m -13.57,2 -1.77,-2 h 12.69 l -1.78,2 z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMartini);
export default __webpack_public_path__ + "static/media/Martini.9ab791c893e8f91ed624d738fd620f3a.svg";
export { ForwardRef as ReactComponent };